/* jshint esversion: 6 */

//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter);
//引用page1页面
import downnss from './downnss.vue';
import down from './page1.vue';
//引用page2页面
import about from './page2.vue';
import user from './user.vue';
//定义routes路由的集合，数组类型
const routes = [
    //单个路由均为对象类型，path代表的是路径，component代表组件
    { path: '/downnss', component: downnss },
    { path: '/down', component: down },
    { path: "/about", component: about },
    // { path: "/", component: down },
    // {path:'',redirect:"down"}
    { path: "", component: downnss },
    //使用冒号标记，当匹配到的时候，参数值会被设置到this.$route.params中
    { path: "/user/:name", component: user },
];

//实例化VueRouter并将routes添加进去
const router = new VueRouter({
    //ES6简写，等于routes：routes
    routes
});

//抛出这个这个实例对象方便外部读取以及访问
export default router;